<template>
  <div class="visualReport-container">
    <div class="content-one" v-show="!isExistBind">
      <el-form ref="queryFormRef1" :model="queryInfo" size="medium" :label-width="formLabelWidth('md')" :rules="queryInfoRules">
        <el-form-item :label="$t('bike.name98')" prop="ebikeId">
          <el-input style="width:400px" v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" class="input"
            clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name84')" prop="searchTime">
          <el-date-picker style="width:400px" v-model="queryInfo.searchTime" type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss" :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')" :end-placeholder="$t('public.name11')"
            :key="$i18n.locale" :picker-options="pickerOptions" @change="changeDateTime">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="bt-layout">
        <el-button type="primary" style="width:500px" size="medium" @click="getJudgeData" :loading="loading1">{{
          $t('public.name3') }}</el-button>
      </div>
      <div v-if="!topData.bindEbikeModel && topData.bindEbikeModel !== null" class="item-one">
        <img slot="reference" class="caution" src="@/assets/caution.png" alt="" />
        <div>{{ $t('bike.name463') }}</div>
      </div>
      <div v-if="topData.ebikeExist !== null" class="item-one">
        <img slot="reference" class="caution" src="@/assets/caution.png" alt="" />
        <div>{{ $t('bike.name464') }}</div>
      </div>
    </div>
    <div class="content-two" v-show="isExistBind">
      <div class="top-filter">
        <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('md')" :inline="true" :rules="queryInfoRules"
          ref="queryFormRef2">
          <el-form-item :label="$t('bike.name98')" prop="ebikeId">
            <el-input v-model="queryInfo.ebikeId" :placeholder="$t('public.name5')" class="input" clearable></el-input>
          </el-form-item>
          <el-button v-if="queryInfo.ebikeId" type="text" style="margin-top: -3px;" @click="showDetailsDialog">{{
            $t('bike.name12') }}</el-button>
          <el-popover v-if="!topData.bindEbikeModel" placement="top-start" width="200" trigger="hover"
            :content="$t('bike.name463')">
            <img slot="reference" class="caution" src="@/assets/caution.png" alt="" />
          </el-popover>
          <el-form-item :label="$t('bike.name84')" prop="searchTime">
            <el-date-picker v-model="queryInfo.searchTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              :range-separator="$t('public.name9')" :start-placeholder="$t('public.name10')"
              :end-placeholder="$t('public.name11')" :key="$i18n.locale" :picker-options="pickerOptions" @change="changeDateTime">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="bt-layout">
              <el-button type="primary" size="medium" @click="getData" :loading="loading">{{ $t('public.name3')
              }}</el-button>
              <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
              <el-button type="primary" icon="el-icon-plus" size="medium" @click="showAddReport">{{ $t('bike.name146')
              }}</el-button>
              <el-button type="primary" size="medium" @click="showDataSourceDialog">{{ $t('bike.name497') }}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="top-ds">
        <div class="item">
          <div class="label">{{ $t('bike.name121') }}<span class="value">{{ topData.odo || '-' }}（Km）</span></div>
          <div class="label">{{ $t('bike.name126') }}
            <span class="value" v-if="topData.speed">{{ Number(topData.speed / 10).toFixed(1) }}（Km/h）</span>
            <span class="value" v-else> -（Km/h）</span>
          </div>
        </div>
        <div class="item">
          <div class="label">{{ $t('bike.name122') }}<span class="value">{{ topData.maxPower || '-' }}（W）</span></div>
          <div class="label margin-top10">{{ $t('bike.name296') }}
            <span class="value" v-if="topData.maxBatteryCurrent !== null">{{ Number(topData.maxBatteryCurrent /
              3).toFixed(1) }}（A）</span>
            <span class="value" v-else>-（A）</span>
          </div>
        </div>
        <!-- <div class="item">
      <div class="label">{{$t('bike.name124')}}<span class="value">{{ topData.maxVoltage || '-' }}（V）</span></div>
      <div class="label margin-top10">{{$t('bike.name125')}}<span class="value">{{ topData.mixVoltage || '-' }}（V）</span></div>
    </div> -->
        <div class="item">
          <div class="label">{{ $t('bike.name127') }}
            <span
              :class="Number(topData.maxTemp) + Number(topData.controllerTemperatureShowDeviation) > Number(topData.controllerTemperatureShowWarnDefaultValue) ? 'value redColor' : 'value'"
              v-if="topData.maxTemp !== null">{{ Number(topData.maxTemp) +
                Number(topData.controllerTemperatureShowDeviation) }}（°C）</span>
            <span class="value" v-else> -（°C）</span>
          </div>
          <div class="label margin-top10">{{ $t('bike.name297') }}
            <span
              :class="Number(topData.maxMotorTemp) + Number(topData.motorTemperatureShowDeviation) > Number(topData.motorTemperatureShowWarnDefaultValue) ? 'value redColor' : 'value'"
              v-if="topData.maxMotorTemp !== null">{{ Number(topData.maxMotorTemp) +
                Number(topData.motorTemperatureShowDeviation) }}（°C）</span>
            <span class="value" v-else> -（°C）</span>
          </div>
          <div class="label margin-top10">{{ $t('bike.name298') }}
            <span
              :class="Number(topData.maxBatteryTemp) + Number(topData.batteryTemperatureShowDeviation) > Number(topData.batteryTemperatureShowWarnDefaultValue) ? 'value redColor' : 'value'"
              v-if="topData.maxBatteryTemp !== null">{{ Number(topData.maxBatteryTemp) +
                Number(topData.batteryTemperatureShowDeviation) }}（°C）</span>
            <span class="value" v-else> -（°C）</span>
          </div>
        </div>
      </div>
      <div class="dydl-wd">
        <div class="wd-container wd-container--map">
          <div class="map-toolbar">
            <div class="map-radio-row">
              <span class="map-type-label">{{ $t('operate.name72') }}</span>
              <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{ $t('operate.name74') }}</el-radio>
              <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{ $t('operate.name73') }}</el-radio>
            </div>
            <div class="map-track-row">
              <div class="gjsd">
                <span class="track-speed-label">{{ $t('operate.name75') }}</span>
                <el-slider v-model="speed" :step="1" :min="10" @change="changeTrackSpeed"></el-slider>
              </div>
              <div class="map-track-actions">
                <el-button type="primary" size="small" :icon="isStart ? 'el-icon-video-pause' : 'el-icon-video-play'"
                  class="map-track-btn" @click="toggleTrackPlay">{{ trackPlayLabel }}</el-button>
                <el-button size="small" icon="el-icon-refresh-right" class="map-track-btn" @click="replayTrack">{{
                  $t('operate.name77') }}</el-button>
              </div>
            </div>
          </div>
          <div class="baidu-map" v-show="mapchange === '1'">
            <div id="mapDiv" class="map"></div>
          </div>
          <div class="gooles-map" v-if="mapchange === '2'">
            <GmapMap :center="markerPoint" :zoom="18" ref="mapRef" class="map" id="mapps">
              <gmap-marker @click="bikePolyLine" :position="startmarkerPoint" :icon="startmarkericon"></gmap-marker>
              <gmap-marker :position="endmarkerPoint" :icon="endmarkericon"></gmap-marker>
            </GmapMap>
          </div>
          <button type="button" class="map-fullscreen-btn" title="全屏" @click="showFullMap">
            <i class="el-icon-full-screen"></i>
          </button>
        </div>
        <div class="wd-container margin-left15">
          <div class="gz-table" :class="{ 'gz-table--en': $i18n.locale === 'en' }">
            <div class="table-title">
              <div class="row1">{{ $t('bike.name129') }}</div>
              <div class="row2">{{ $t('bike.name130') }}</div>
              <div class="row3">{{ $t('bike.name131') }}</div>
              <div class="row4">{{ $t('bike.name110') }}</div>
              <div class="row5 cell-action">{{ $t('bike.name46') }}</div>
            </div>
            <div class="table-rows">
              <div class="item-content" v-for="(item, index) in tableList" :key="index"
                :class="clickIndex === index ? 'item-content-active' : ''">
                <div class="row1 cell-time" v-if="item.list.length > 1 && item.list">
                  <img v-if="clickIndex === index" class="row-active-icon" :src="caution" alt="" />
                  <el-tooltip :content="faultTimeRangeTip(item)" placement="top" :open-delay="300">
                    <div class="time-range">
                      <span class="time-link" @click.stop="handlerIndex(item, index, 0)">{{ item.list[0].dataTime }}</span>
                      <span class="time-link" @click.stop="handlerIndex(item, index, item.list.length - 1)">{{
                        item.list[item.list.length - 1].dataTime }}</span>
                    </div>
                  </el-tooltip>
                </div>
                <div class="row1 cell-time" v-else-if="item.list.length === 1 && item.list" @click="handlerIndex(item, index, 0)">
                  <img v-if="clickIndex === index" class="row-active-icon" :src="caution" alt="" />
                  <el-tooltip :content="item.list[0].dataTime" placement="top" :open-delay="300">
                    <span class="time-link">{{ item.list[0].dataTime }}</span>
                  </el-tooltip>
                </div>
                <div class="row1 cell-time" v-else></div>
                <div v-if="item.list.length > 0" class="row2 cell-code cell-wrap">
                  {{ item.list[0].faultCode }}
                </div>
                <div v-else class="row2 cell-code"></div>
              <div v-if="item.list.length > 0" class="row3 cell-msg">
                <el-tooltip
                  v-if="item.list[0].faultCode !== '48' && localizedFaultMessage(item.list[0].faultCode, item.list[0].faultMessage)"
                  :content="localizedFaultMessage(item.list[0].faultCode, item.list[0].faultMessage)"
                  placement="top"
                  :open-delay="300"
                >
                  <span class="cell-ellipsis">{{ localizedFaultMessage(item.list[0].faultCode, item.list[0].faultMessage) }}</span>
                </el-tooltip>
              </div>
                <div v-else class="row3 cell-msg"></div>
                <div v-if="item.list.length > 0" class="row4 cell-remark cell-wrap">
                  <span v-if="item.list[0].isLocation === 0">{{ $t('public.name59') }}</span>
                </div>
                <div v-else class="row4 cell-remark"></div>
                <div class="row5 cell-action">
                  <el-button @click="showFaultDetalis(item)" type="text">{{ $t('bike.name12') }}</el-button>
                </div>
              </div>
              <div v-if="tableList.length === 0" class="nodata">{{ $t('bike.name133') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dydl-wd margin-top20">
        <div style="width:30%;border: 1px solid #f1f1f1;padding: 10px;">
          <div style="display: flex;justify-content: space-between;">
            <div>
              {{ $t('public.name55') }}（{{ batteryVoltage.batteryVoltageList.length }}）
            </div>
            <div> {{ $t('public.name56') }}{{ batteryVoltage.dateTime }}</div>
          </div>
          <el-table height="360px" :data="batteryVoltage.batteryVoltageList"
            :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
            <el-table-column :label="$t('public.name58')" prop="batteryNo" width="80"></el-table-column>
            <el-table-column :label="$t('public.name57')" prop="batteryVoltage">
              <template slot-scope="scope">
                <div>
                  {{ (scope.row.batteryVoltage / 100).toFixed(2) }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dydl-container margin-left15" style="width:35%;">
          <div class="bll-select">
            <div>
              <el-select v-model="blData" multiple collapse-tags :placeholder="$t('public.name1')" @change="changeBL">
                <el-option v-for="item in localizedTypeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="dydl">
            <MultipleLine ref="MultipleLineChart" chartid="MultipleLineChart" />
          </div>
        </div>
        <div class="dydl-container margin-left15" style="width:35%;">
          <div class="dcdy">
            <div class="writing-mode">{{ $t('bike.name55') }}</div>
            <div>/</div>
            <div>V</div>
          </div>
          <div class="dydl" id="dydlChart" ref="dydlChart"></div>
          <div class="dcdl">
            <div class="writing-mode">{{ $t('bike.name56') }}</div>
            <div>/</div>
            <div>A</div>
            <div class="writing-mode">{{ $t('bike.name495') }}</div>
          </div>
        </div>
      </div>
      <div class="dydl-wd margin-top20">
        <div class="wd-container">
          <div class="wd-text">
            <div class="writing-mode">{{ $t('bike.name144') }}</div>
            <div>/</div>
            <div>°C</div>
          </div>
          <div class="wd" id="wdChart" ref="wdChart"></div>
        </div>
        <div class="dydl-container  margin-left15">
          <div class="dcdy">
            <div class="writing-mode">{{ $t('bike.name140') }}</div>
          </div>
          <div class="dydl" id="glsdChart" ref="glsdChart"></div>
          <div class="dcdl">
            <div class="writing-mode">{{ $t('bike.name141') }}</div>
            <div>/</div>
            <div>km/h</div>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        :fullscreen="true"
        :modal="false"
        append-to-body
        custom-class="report-map-fullscreen-dialog"
        :title="$t('bike.name82')"
        @opened="handleFullMapOpened"
        @closed="handleFullMapClosed"
      >
        <div class="full-map-shell">
          <div class="map-toolbar">
            <div class="map-radio-row">
              <span class="map-type-label">{{ $t('operate.name72') }}</span>
              <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{ $t('operate.name74') }}</el-radio>
              <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{ $t('operate.name73') }}</el-radio>
            </div>
            <div class="map-track-row">
              <div class="gjsd">
                <span class="track-speed-label">{{ $t('operate.name75') }}</span>
                <el-slider v-model="speed" :step="1" :min="10" @change="changeTrackSpeed"></el-slider>
              </div>
              <div class="map-track-actions">
                <el-button type="primary" size="small" :icon="isStart ? 'el-icon-video-pause' : 'el-icon-video-play'"
                  class="map-track-btn" @click="toggleTrackPlay">{{ trackPlayLabel }}</el-button>
                <el-button size="small" icon="el-icon-refresh-right" class="map-track-btn" @click="replayTrack">{{
                  $t('operate.name77') }}</el-button>
              </div>
            </div>
          </div>
          <div class="full-map-body">
            <div class="full-map-pane" v-show="mapchange === '1'">
              <div id="mapDivFull" class="map map--full"></div>
            </div>
            <div class="full-map-pane" v-show="mapchange === '2'">
              <GmapMap
                v-if="dialogVisible && mapchange === '2'"
                :center="markerPoint"
                :zoom="18"
                ref="mapRefFull"
                class="map map--full"
                id="mappsFull"
                style="width: 100%; height: 100%;"
              >
                <gmap-marker :position="startmarkerPoint" :icon="startmarkericon"></gmap-marker>
                <gmap-marker :position="endmarkerPoint" :icon="endmarkericon"></gmap-marker>
              </GmapMap>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!--添加报告-->
    <AppDialog size="sm" :title="$t('bike.name146')" :visible.sync="reportDialog" v-if="reportDialog" :before-close="close">
      <el-form ref="reportFormRef" :label-width="formLabelWidth('lg2')" :model="reportInfo" class="width100">
        <el-form-item :label="$t('bike.name188')" prop="tenantId">
          <el-cascader style="width:100%" ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" :show-all-levels="false"
            @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }"
            clearable></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('bike.name65')" prop="ebikeId">
          <el-select v-model="reportInfo.ebikeId" :placeholder="$t('public.name1')" class="width100" disabled>
            <el-option v-for="item in ebikeIdOptions" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('bike.name145')" prop="startTime">
          <el-date-picker v-model="reportInfo.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('public.name6')" class="width100" disabled> </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('bike.name151')" prop="endTime">
          <el-date-picker v-model="reportInfo.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('public.name6')" class="width100" disabled> </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submitReport" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </template>
    </AppDialog>
    <!--车辆详情-->
    <VehicleDetailsAppDialog
      ref="vehicleDetailsDialog"
      :visible.sync="eBikeDetailsDialog"
      :e-bike-id="eBikeId"
      :type="type"
    />
    <AppDialog size="md" width="640px" :title="$t('bike.name74')" v-if="dialogFaultVisible" :visible.sync="dialogFaultVisible" :before-close="handleCloseFault">
      <el-table :data="faultDetalisList" style="width: 100%">
        <el-table-column prop="dataTime" :label="$t('bike.name129')" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.dataTime | tzDisplay }}
          </template>
        </el-table-column>
        <el-table-column prop="faultCode" :label="$t('bike.name130')" width="88">
        </el-table-column>
        <el-table-column prop="faultMessage" :label="$t('bike.name131')">
          <template slot-scope="scope">
            {{ localizedFaultMessage(scope.row.faultCode, scope.row.faultMessage) }}
          </template>
        </el-table-column>
        <el-table-column prop="isLocation" :label="$t('bike.name496')">
          <template slot-scope="scope">
            <div>{{ [$t('public.name60'), $t('bike.name45')][scope.row.isLocation] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </AppDialog>
    <!--数据源-->
    <AppDialog size="lg" width="90%" :title="$t('bike.name497')" :visible.sync="dataSourceDialog" v-if="dataSourceDialog" :before-close="closeDataSourceDialog">
      <span >
        <el-button @click="toggleColumnConfig">{{ $t('bike.name577') }}</el-button>
      </span>
      <el-table :data="dataSourceList" v-loading="dataSourceLoading" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" style="width: 100%" max-height="600">
        <el-table-column v-for="column in dataSourceColumns" :key="column.prop" :prop="column.prop" :label="column.label" :width="column.width || 120"></el-table-column>
      </el-table>
    </AppDialog>
    <!--列配置对话框-->
    <AppDialog size="sm" width="500px" :title="$t('bike.name577')" :visible.sync="showColumnConfig" v-if="showColumnConfig" >
      <el-checkbox v-model="selectAll" @change="toggleSelectAll">{{ $t('bike.name580') }}</el-checkbox>
      <el-divider></el-divider>
      <el-checkbox-group v-model="selectedColumns">
        <el-checkbox v-for="column in allColumns" :key="column.prop" :label="column.prop" style="display: block; margin: 10px 0;">
          {{ column.label }}
        </el-checkbox>
      </el-checkbox-group>
      <template #footer>
        <el-button @click="showColumnConfig = false">{{ $t('public.name14') }}</el-button>
        <el-button type="primary" @click="saveColumnConfig">{{ $t('bike.name581') }}</el-button>
      </template>
    </AppDialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getSize } from '@/utils/utils.js'
// import { BmlLushu } from 'vue-baidu-map'
import { gmapApi } from 'vue2-google-maps'
import MultipleLine from '@/components/MultipleLine1.vue'
import { tenantList } from '@/api/manage.js'
import { lineCharTemp, lineChartBatteryVoltageCurrent, lineChartSpeedPowerPercent, listFields, lineChartFields, lngLatAlt, statistics, listEbikeIdByTenantId, ebikeDebugReportAdd, ebikeDBatteryVoltageList, getEbikeDebugReportList } from '@/api/bike.js'
import AppDialog from '@/components/AppDialog/index.vue'
import VehicleDetailsAppDialog from '@/components/VehicleDetailsAppDialog.vue'
import {
  buildVisualReportGrid,
  buildVisualReportDataZoom,
  buildAxisTooltipPosition
} from './visualReportChartOptions.js'
import { buildRecentHoursShortcuts, buildDisabledFutureDate } from '@/utils/datePickerShortcuts.js'
import {
  getKeepAliveFieldDisplayName,
  rebuildKeepAliveLegend
} from '@/utils/keepAliveFieldLabels.js'
import { getFaultCodeLabel } from '@/utils/faultCodeLabels.js'
import { clearFormValidateOnLangChange } from '@/utils/i18nFormHelpers.js'
import { defaultMapChangeReport } from '@/config/flavor'
import { toMapLngLat, resolveInitialZoom } from '@/utils/mapCoords'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    google: gmapApi,
    // 全选状态
    selectAll: {
      get () {
        return this.selectedColumns.length === this.allColumns.length && this.allColumns.length > 0
      },
      set (value) {
        this.toggleSelectAll(value)
      }
    },
    trackPlayLabel () {
      if (this.isStart) return this.$t('operate.name78')
      if (this.hasTrackProgress()) return this.$t('operate.name182')
      return this.$t('operate.name76')
    },
    queryInfoRules () {
      return {
        ebikeId: [
          {
            required: true,
            message: this.$t('bike.name473'),
            trigger: 'blur'
          }
        ],
        searchTime: [
          {
            required: true,
            message: this.$t('bike.name483'),
            trigger: 'blur'
          }
        ]
      }
    },
    pickerOptions () {
      return {
        shortcuts: buildRecentHoursShortcuts(this),
        disabledDate: buildDisabledFutureDate(this)
      }
    },
    localizedTypeOptions () {
      return (this.typeOptions || []).map((field) => ({
        ...field,
        name: getKeepAliveFieldDisplayName(this, field)
      }))
    }
  },
  components: {
    // BmlLushu,
    MultipleLine,
    VehicleDetailsAppDialog,
    AppDialog
  },
  data () {
    return {
      tdtMap: null,
      tdtMapFull: null,
      carTrack: null,
      carTrackFull: null,
      dialogFaultVisible: false,
      faultDetalisList: [],
      eBikeDetailsDialog: false,
      eBikeId: '',
      type: 2,
      loading1: false,
      tenantIds: [],
      tenantOptions: [],
      ebikeIdOptions: [],
      isExistBind: false,
      topData: {
        bindEbikeModel: true,
        speed: 0,
        maxTemp: 0,
        minTemp: 0,
        ebikeExist: null
      },
      loading: false,
      dialogVisible: false,
      caution: require('@/assets/caution1.png'),
      lineChart1: null,
      lineChart2: null,
      blData: [],
      blLabel: '',
      typeOptions: [],
      // 缺省来自 flavor：国内 '1'(tdt) / 海外 '2'(google)；编码与数据总览相反
      mapchange: defaultMapChangeReport,
      car_animate: null,
      car_animate_full: null,
      count: 0,
      count2: 0,
      markerPoint: {
        lng: 0,
        lat: 0
      },
      icon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      startmarkericon: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      endmarkericon: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      bikemarkericon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      startmarkerPoint: {
        lng: 0,
        lat: 0
      },
      endmarkerPoint: {
        lng: 0,
        lat: 0
      },
      startmarkericonbaidu: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      endmarkericonbaidu: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      pointsmarkericon: {
        url: require('@/assets/caution.png'),
        size: {
          width: 16,
          height: 16
        },
        opts: {
          imageSize: {
            width: 16,
            height: 16
          }
        }
      },
      pointsmarkericon1: {
        url: require('@/assets/caution1.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      markerPointbaidu: {
        lng: 0,
        lat: 0
      },
      startmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      endmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      pathbaiduFault: [],
      markerBlack: null,
      markerBlackFull: null,
      BMap: null,
      map: null,
      pointsMarker: [],
      path: [],
      bikePath: [],
      speed: 20,
      pathbaidu: [],
      playbaidu: false,
      isStart: false,
      clickIndex: -1,
      queryInfo: {
        searchTime: [],
        ebikeId: ''
      },
      tableList: [],
      xWDData: [],
      yWDData1: [],
      yWDData2: [],
      flightPath: null,
      flightPathFull: null,
      googleFaultPath: null,
      googleFault: [],
      yWDData3: [],
      xDLDYData: [],
      yDLDYData1: [],
      yDLDYData2: [],
      xSDGLData: [],
      ySDGLData1: [],
      ySDGLData2: [],
      xBLData: [],
      blChartSeriesArrays: [],
      yBLData: [],
      bLLegend: [],
      batteryVoltage: {
        dateTime: '',
        batteryVoltageList: []
      },
      timer: null,
      dataTime: '',
      pickerMinDate: '',
      maxDate: null,
      minDate: null,
      reportDialog: false,
      dataSourceDialog: false,
      dataSourceList: [],
      dataSourceRawList: [],
      dataSourceCustomColumnCount: 0,
      dataSourceColumns: [],
      dataSourceLoading: false,
      // 列配置
      allColumns: [],
      selectedColumns: [],
      showColumnConfig: false,
      reportInfo: {
        tenantId: '',
        ebikeId: '',
        startTime: '',
        endTime: ''
      },
      trackPolyline: null,
      trackPolylineFull: null
    }
  },
  created () {
    this.queryInfo.searchTime = []
    this.queryInfo.ebikeId = ''
  },
  mounted () {
    window.addEventListener('resize', this.chartResize)
    this.lineChart1 = this.$echarts.init(this.$refs.dydlChart, null, { renderer: 'svg' })
    this.lineChart2 = this.$echarts.init(this.$refs.wdChart, null, { renderer: 'svg' })
    this.lineChart3 = this.$echarts.init(this.$refs.glsdChart, null, { renderer: 'svg' })
    this.$bus.$on('lang', this.handleLangChange)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
    this.$bus.$off('lang', this.handleLangChange)
    ;['carTrack', 'carTrackFull'].forEach((key) => {
      if (this[key]) {
        try {
          this[key].pause()
        } catch (e) { /* ignore */ }
      }
    })
    this.tdtMap = null
    this.tdtMapFull = null
    this.carTrack = null
    this.carTrackFull = null
    clearInterval(this.car_animate)
    this.car_animate = null
    clearInterval(this.car_animate_full)
    this.car_animate_full = null
    ;[this.lineChart1, this.lineChart2, this.lineChart3].forEach((chart) => {
      if (chart) {
        chart.dispose()
      }
    })
    this.lineChart1 = null
    this.lineChart2 = null
    this.lineChart3 = null
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    localizedFaultMessage (faultCode, faultMessage) {
      return getFaultCodeLabel(this, faultCode, faultMessage)
    },
    accountSearchRange () {
      // 日期时间范围转账号时区查询参数
      return this.$tz.rangeToAccountQuery(this.queryInfo.searchTime)
    },
    showFaultDetalis (item) {
      this.faultDetalisList = item.list
      this.dialogFaultVisible = true
    },
    faultTimeRangeTip (item) {
      if (!item.list || !item.list.length) return ''
      if (item.list.length === 1) return item.list[0].dataTime
      return `${item.list[0].dataTime} ~ ${item.list[item.list.length - 1].dataTime}`
    },
    handleCloseFault () {
      this.dialogFaultVisible = false
    },
    showDetailsDialog () {
      this.eBikeId = this.queryInfo.ebikeId
      this.eBikeDetailsDialog = true
    },
    closeEBikeDetailsDialog () {
      if (this.$refs.vehicleDetailsDialog) {
        this.$refs.vehicleDetailsDialog.close()
      }
      this.eBikeDetailsDialog = false
    },
    getJudgeData () {
      this.$refs.queryFormRef1.validate(async (valid) => {
        if (!valid) return
        this.loading1 = true
        const { startTime, endTime } = this.accountSearchRange()
        const data = {
          ebikeId: this.queryInfo.ebikeId,
          startTime,
          endTime
        }
        statistics(data).then((res) => {
          this.loading1 = false
          if (res.code === 200) {
            this.topData = res.data
            if (!this.topData.ebikeExist) {
              this.isExistBind = false
            } else {
              if (this.topData.bindEbikeModel) {
                this.isExistBind = true
                this.getData()
              } else {
                this.isExistBind = false
              }
            }
          }
        }).catch(() => {
          this.loading1 = false
        })
      })
    },
    showFullMap () {
      this.dialogVisible = true
    },
    handleFullMapOpened () {
      const refreshFullMap = () => {
        if (this.mapchange === '1') {
          this.refreshTdtMap(true)
        } else {
          this.refreshGoogleMap(true)
        }
      }
      this.$nextTick(() => {
        refreshFullMap()
        setTimeout(refreshFullMap, 250)
        setTimeout(refreshFullMap, 700)
      })
    },
    handleFullMapClosed () {
      this.clearTdtOverlays(true)
      this.tdtMapFull = null
      this.carTrackFull = null
      this.trackPolylineFull = null
      if (this.flightPathFull) {
        this.flightPathFull.setMap(null)
        this.flightPathFull = null
      }
      if (this.markerBlackFull) {
        this.markerBlackFull.setMap(null)
        this.markerBlackFull = null
      }
      clearInterval(this.car_animate_full)
      this.car_animate_full = null
    },
    getMapCtx (fullscreen = false) {
      if (fullscreen) {
        return {
          containerId: 'mapDivFull',
          tdtMapKey: 'tdtMapFull',
          carTrackKey: 'carTrackFull',
          googleRef: 'mapRefFull',
          flightPathKey: 'flightPathFull',
          markerKey: 'markerBlackFull',
          trackPolylineKey: 'trackPolylineFull',
          animateKey: 'car_animate_full'
        }
      }
      return {
        containerId: 'mapDiv',
        tdtMapKey: 'tdtMap',
        carTrackKey: 'carTrack',
        googleRef: 'mapRef',
        flightPathKey: 'flightPath',
        markerKey: 'markerBlack',
        trackPolylineKey: 'trackPolyline',
        animateKey: 'car_animate'
      }
    },
    getActiveMapCtx () {
      return this.getMapCtx(this.dialogVisible)
    },
    changeDateTime (e) {
      if (this.$moment(e[1]).valueOf() - this.$moment(e[0]).valueOf() > 21600000) {
        this.$message({
          message: this.$t('bike.name484'),
          type: 'warning'
        })
        this.queryInfo.searchTime = []
      }
    },
    getData () {
      this.pauseTrack()
      this.clearTdtOverlays(false)
      if (this.dialogVisible) {
        this.clearTdtOverlays(true)
      }
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.clickIndex = -1
      this.isStart = false
      this.tableList = []
      this.pathbaidu = []
      this.pathbaiduFault = []
      this.initBikeIcons().finally(() => {
      this.$refs.queryFormRef2.validate(async (valid) => {
        if (!valid) return
        this.timer = setInterval(this.getEbikeDBatteryVoltageList, 10000)
        this.xWDData = []
        this.yWDData1 = []
        this.yWDData2 = []
        this.yWDData3 = []
        this.xDLDYData = []
        this.yDLDYData1 = []
        this.yDLDYData2 = []
        this.xSDGLData = []
        this.ySDGLData1 = []
        this.ySDGLData2 = []
        this.xBLData = []
        this.yBLData = []
        this.blData = []
        this.bLLegend = []
        this.firstcharts()
        this.secondcharts()
        this.thirdcharts()
        // this.fourthcharts()
        const { startTime, endTime } = this.accountSearchRange()
        const data = {
          ebikeId: this.queryInfo.ebikeId,
          startTime,
          endTime
        }
        statistics(data)
          .then((res) => {
            this.topData = res.data
            lineCharTemp(data)
              .then((res) => {
                res.data.map((item) => {
                  this.xWDData.push(item.dataTime)
                  var controllerTemp = 0
                  if (item.controllerTemp !== null) {
                    controllerTemp = Number(item.controllerTemp) + Number(this.topData.controllerTemperatureShowDeviation)
                  }
                  this.yWDData1.push(controllerTemp)
                  var motorTemp = 0
                  if (item.motorTemp !== null) {
                    motorTemp = Number(item.motorTemp) + Number(this.topData.motorTemperatureShowDeviation)
                  }
                  this.yWDData2.push(motorTemp)
                  var batteryTemp = 0
                  if (item.batteryTemp !== null) {
                    batteryTemp = Number(item.batteryTemp) + Number(this.topData.batteryTemperatureShowDeviation)
                  }
                  this.yWDData3.push(batteryTemp)
                })
                this.secondcharts()
                this.scheduleChartsResize()
              })
              .catch(() => { })
          })
          .catch(() => { })
        lineChartBatteryVoltageCurrent(data)
          .then((res) => {
            res.data.map((item) => {
              this.xDLDYData.push(item.dataTime)
              const batteryVoltage = Number(item.batteryVoltage / 10).toFixed(1)
              this.yDLDYData1.push(batteryVoltage)
              const batteryCurrent = Number(item.batteryCurrent / 3).toFixed(1)
              this.yDLDYData2.push(batteryCurrent)
            })
            this.firstcharts()
            this.scheduleChartsResize()
          })
          .catch(() => { })
        lineChartSpeedPowerPercent(data)
          .then((res) => {
            res.data.map((item) => {
              this.xSDGLData.push(item.dataTime)
              this.ySDGLData1.push(item.powerPercent)
              const speed = item.speedMessage
              this.ySDGLData2.push(speed)
            })
            this.thirdcharts()
            this.scheduleChartsResize()
          })
          .catch(() => { })
        listFields()
          .then((res) => {
            this.typeOptions = res.data
            if (this.typeOptions.length && !this.blData.length) {
              this.blData.push(this.typeOptions[0].id)
            }
            this.syncKeepAliveFieldLabels()
            this.getBLChartData()
          })
          .catch(() => { })
        this.getEbikeDBatteryVoltageList()
        this.getlngLatAlt()
        this.scheduleChartsResize()
      })
      })
    },
    getEbikeDBatteryVoltageList () {
      ebikeDBatteryVoltageList({ ebikeId: this.queryInfo.ebikeId })
        .then((res) => {
          this.batteryVoltage = {
            dateTime: res.data ? res.data.dateTime : '',
            batteryVoltageList: res.data ? res.data.batteryVoltageDetails : []
          }
        })
        .catch(() => { })
    },
    changeBL (e) {
      this.blData = e
      this.bLLegend = []
      this.xBLData = []
      this.syncKeepAliveFieldLabels()
      this.getBLChartData()
    },

    syncKeepAliveFieldLabels () {
      this.bLLegend = rebuildKeepAliveLegend(this, this.typeOptions, this.blData)
      const firstField = this.typeOptions.find((item) => item.id === this.blData[0])
      this.blLabel = firstField ? getKeepAliveFieldDisplayName(this, firstField) : ''
    },

    getBLChartData () {
      // console.log('this.typeOptions====', this.typeOptions)
      // console.log('this.blData====', this.blData)
      this.xBLData = []
      const { startTime, endTime } = this.accountSearchRange()
      const data = {
        ebikeId: this.queryInfo.ebikeId,
        startTime,
        endTime,
        fieldKeys: this.blData.join(',')
      }
      lineChartFields(data)
        .then((res) => {
          const arrays = []
          this.blData.map(() => {
            arrays.push([])
          })
          // console.log('====', arrays.length)
          res.data.map((item) => {
            this.xBLData.push(item.dataTime)
            for (const key in item.keyValue) {
              var element = item.keyValue[key]
              this.blData.map((item, index) => {
                if (item === key) {
                  if (key === 'CONTROLLER_TEMP') {
                    element = Number(element) + Number(this.topData.controllerTemperatureShowDeviation)
                  } else if (key === 'BATTERY_TEMP') {
                    element = Number(element) + Number(this.topData.batteryTemperatureShowDeviation)
                  } else if (key === 'MOTOR_TEMP') {
                    element = Number(element) + Number(this.topData.motorTemperatureShowDeviation)
                  }
                  arrays[index].push(element)
                }
              })
            }
          })
          this.blChartSeriesArrays = arrays
          this.$refs.MultipleLineChart.setOptions(this.xBLData, arrays, this.bLLegend)
          this.scheduleChartsResize()
        })
        .catch(() => { })
    },
    refreshBlChartOnLangChange () {
      this.syncKeepAliveFieldLabels()
      if (this.xBLData.length && this.blChartSeriesArrays.length && this.$refs.MultipleLineChart) {
        this.$refs.MultipleLineChart.setOptions(this.xBLData, this.blChartSeriesArrays, this.bLLegend)
      }
    },
    resetQuery () {
      this.queryInfo.ebikeId = ''
      this.queryInfo.searchTime = []
      this.getData()
    },
    handleLangChange () {
      this.applyDataSourceI18n()
      if (this.blData.length && this.queryInfo.ebikeId) {
        this.refreshBlChartOnLangChange()
      }
      clearFormValidateOnLangChange(this, ['queryFormRef1', 'queryFormRef2', 'reportFormRef'])
      this.scheduleChartsResize()
    },
    buildDataSourceColumns (customColumnCount) {
      const fixedColumns = [
        { prop: 'dataTime', label: this.$t('bike.name498'), width: 180 },
        { prop: 'lockStatusLabel', label: this.$t('home.name27'), width: 100 },
        { prop: 'soc', label: this.$t('bike.name499'), width: 100 },
        { prop: 'lng', label: this.$t('bike.name525'), width: 120 },
        { prop: 'lat', label: this.$t('bike.name526'), width: 120 },
        { prop: 'alt', label: this.$t('bike.name500'), width: 100 },
        { prop: 'gpsSpeed', label: this.$t('bike.name501'), width: 140 },
        { prop: 'isLocation', label: this.$t('bike.name502'), width: 120 },
        { prop: 'isLocationFault', label: this.$t('public.name59'), width: 120 },
        { prop: 'speed', label: this.$t('bike.name522'), width: 100 },
        { prop: 'controllerTemp', label: this.$t('bike.name523'), width: 120 },
        { prop: 'motorTemp', label: this.$t('bike.name524'), width: 120 },
        { prop: 'batteryTemp', label: this.$t('bike.name503'), width: 120 },
        { prop: 'batteryVoltage', label: this.$t('bike.name504'), width: 100 },
        { prop: 'batteryCurrent', label: this.$t('bike.name505'), width: 100 },
        { prop: 'batteryChargeStatusLabel', label: this.$t('bike.name506'), width: 120 },
        { prop: 'powerPercentage', label: this.$t('bike.name507'), width: 100 },
        { prop: 'powerPercent', label: this.$t('bike.name140'), width: 100 },
        { prop: 'odo', label: this.$t('bike.name508'), width: 100 },
        { prop: 'cadence', label: this.$t('bike.name509'), width: 80 },
        { prop: 'faultCode', label: this.$t('bike.name510'), width: 100 },
        { prop: 'faultCodeLabel', label: this.$t('bike.name511'), width: 150 },
        { prop: 'batteryCount', label: this.$t('bike.name512'), width: 140 }
      ]
      const batteryPackColumns = []
      for (let i = 1; i <= customColumnCount; i++) {
        batteryPackColumns.push({
          prop: `batteryPack${i}Voltage`,
          label: this.$t('bike.name513', { num: i }),
          width: 160
        })
      }
      return [...fixedColumns, ...batteryPackColumns]
    },
    mapDataSourceItem (rawItem) {
      const item = { ...rawItem }
      item.lockStatusLabel = [
        this.$t('bike.name514'),
        this.$t('bike.name515'),
        this.$t('bike.name516'),
        this.$t('bike.name517')
      ][rawItem.lockStatus]
      item.isLocation = [this.$t('bike.name519'), this.$t('bike.name518')][rawItem.isLocation]
      item.isLocationFault = [this.$t('bike.name252'), this.$t('bike.name251')][rawItem.isLocationFault]
      if (item.batteryCurrent < 0) {
        item.batteryChargeStatusLabel = this.$t('bike.name520')
      } else {
        item.batteryChargeStatusLabel = this.$t('bike.name521')
      }
      if (item.speed) {
        item.speed = (Number(item.speed) / 10).toFixed(1)
      }
      item.batteryVoltage = (Number(item.batteryVoltage) / 10).toFixed(1)
      item.batteryCurrent = (Number(item.batteryCurrent) / 3).toFixed(1)
      item.odo = (Number(item.odo) / 10).toFixed(1)
      item.controllerTemp = Number(item.controllerTemp) + Number(this.topData.controllerTemperatureShowDeviation)
      item.motorTemp = Number(item.motorTemp) + Number(this.topData.motorTemperatureShowDeviation)
      item.batteryTemp = Number(item.batteryTemp) + Number(this.topData.batteryTemperatureShowDeviation)
      if (item.batteryVoltageList && Array.isArray(item.batteryVoltageList)) {
        item.batteryVoltageList.forEach((voltage, index) => {
          item[`batteryPack${index + 1}Voltage`] = (Number(voltage) / 100).toFixed(2)
        })
      }
      item.faultCodeLabel = getFaultCodeLabel(this, rawItem.faultCode, rawItem.faultMessage)
      return item
    },
    applyDataSourceI18n () {
      if (!this.dataSourceRawList.length) return
      const allColumns = this.buildDataSourceColumns(this.dataSourceCustomColumnCount)
      this.allColumns = allColumns
      if (!this.selectedColumns.length) {
        this.selectedColumns = allColumns.map(col => col.prop)
      }
      this.dataSourceColumns = allColumns.filter(col =>
        this.selectedColumns.includes(col.prop)
      )
      this.dataSourceList = this.dataSourceRawList.map(item => this.mapDataSourceItem(item))
    },
    scheduleChartsResize () {
      this.chartResize()
      if (this.$refs.MultipleLineChart) {
        this.$refs.MultipleLineChart.chartResize()
      }
      ;[250, 700].forEach((delay) => {
        setTimeout(() => {
          this.chartResize()
          if (this.$refs.MultipleLineChart) {
            this.$refs.MultipleLineChart.chartResize()
          }
        }, delay)
      })
    },
    chartResize () {
      if (this.mapchange === '1') {
        if (this.tdtMap && typeof this.tdtMap.checkResize === 'function') {
          this.tdtMap.checkResize()
        }
        if (this.dialogVisible && this.tdtMapFull && typeof this.tdtMapFull.checkResize === 'function') {
          this.tdtMapFull.checkResize()
        }
      }
      if (this.lineChart2) {
        setTimeout(() => {
          this.lineChart2.resize()
          this.secondcharts()
        }, 10)
      }
      if (this.lineChart1) {
        setTimeout(() => {
          this.lineChart1.resize()
          this.firstcharts()
        }, 10)
      }
      if (this.lineChart3) {
        setTimeout(() => {
          this.lineChart3.resize()
          this.thirdcharts()
        }, 10)
      }
    },
    async firstcharts () {
      const option = {
        title: { text: this.$t('bike.name134'), left: 'center' },
        color: ['#42bf7c', '#5a7ff1'],
        grid: buildVisualReportGrid(),
        tooltip: {
          trigger: 'axis',
          position: buildAxisTooltipPosition()
        },
        legend: {
          data: [this.$t('bike.name142') + '(V)', this.$t('bike.name143') + '(A)'],
          top: getSize(20)
        },
        dataZoom: buildVisualReportDataZoom(),
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.xDLDYData
        },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: [
          {
            name: this.$t('bike.name142') + '(V)',
            yAxisIndex: 0,
            data: this.yDLDYData1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name143') + '(A)',
            yAxisIndex: 1,
            data: this.yDLDYData2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart1.setOption(option)
    },
    async secondcharts () {
      const option = {
        title: { text: this.$t('bike.name135'), left: 'center' },
        color: ['#42bf7c', '#5a7ff1', '#8a2ff1'],
        grid: buildVisualReportGrid(),
        tooltip: {
          trigger: 'axis',
          position: buildAxisTooltipPosition()
        },
        legend: {
          data: [this.$t('bike.name137'), this.$t('bike.name138'), this.$t('bike.name139')],
          top: getSize(20)
        },
        dataZoom: buildVisualReportDataZoom(),
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.xWDData
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: this.$t('bike.name137'),
            data: this.yWDData1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name138'),
            data: this.yWDData2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name139'),
            data: this.yWDData3,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart2.setOption(option)
    },
    async thirdcharts () {
      const option = {
        title: { text: this.$t('bike.name136'), left: 'center' },
        color: ['#42bf7c', '#5a7ff1'],
        grid: buildVisualReportGrid(),
        tooltip: {
          trigger: 'axis',
          position: buildAxisTooltipPosition()
        },
        legend: {
          data: [this.$t('bike.name140'), this.$t('bike.name141') + '(km/h)'],
          top: getSize(20)
        },
        dataZoom: buildVisualReportDataZoom(),
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.xSDGLData
        },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: [
          {
            name: this.$t('bike.name140'),
            yAxisIndex: 0,
            data: this.ySDGLData1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name141') + '(km/h)',
            yAxisIndex: 1,
            data: this.ySDGLData2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart3.setOption(option)
    },
    handlerIndex (item, index, dataIndex) {
      const ctx = this.getActiveMapCtx()
      if (this.mapchange === '1') {
        this.pathbaiduFault = []
        this.dataTime = item.list[dataIndex].dataTime
        item.list.map((items) => {
          if (items.lng && items.lat) {
            this.pathbaiduFault.push({ lng: items.lng, lat: items.lat })
          }
        })
        this.clickIndex = index
        const that = this
        const tdtMap = this[ctx.tdtMapKey]
        if (!tdtMap) return

        if (that[ctx.trackPolylineKey]) {
          tdtMap.removeOverLay(that[ctx.trackPolylineKey])
          that[ctx.trackPolylineKey] = null
        }

        var T = window.T

        if (this.pathbaiduFault && this.pathbaiduFault.length > 0) {
          const trackPoints = this.pathbaiduFault.map(item => {
            return new T.LngLat(item.lng || item[0], item.lat || item[1])
          })

          that[ctx.trackPolylineKey] = new T.Polyline(trackPoints, {
            color: '#ff0000',
            weight: 8,
            opacity: 0.8,
          })

          tdtMap.addOverLay(that[ctx.trackPolylineKey])
        }
      } else {
        this.googleFault = []
        this.dataTime = item.list[dataIndex].dataTime
        item.list.map((items) => {
          if (items.lng && items.lat) {
            this.clickIndex = index
            this.googleFault.push({ lng: Number(items.lng), lat: Number(items.lat) })
          }
        })
        const flightPath = this[ctx.flightPathKey]
        if (flightPath) {
          flightPath.setMap(null)
        }
        if (this.googleFaultPath) {
          this.googleFaultPath.setMap(null)
        }
        const google = window.google
        const mapRef = this.$refs[ctx.googleRef]
        if (!google || !google.maps || !mapRef) return
        mapRef.$mapPromise.then((map) => {
          const mainCoords = this.getGoogleLatLngPath()
          if (mainCoords.length > 0) {
            this[ctx.flightPathKey] = new google.maps.Polyline({
              path: mainCoords,
              strokeColor: '#275aff',
              strokeOpacity: 0.8,
              strokeWeight: 5,
              map
            })
          }
          const faultCoords = this.googleFault.map((p) => ({
            lat: Number(p.lat),
            lng: Number(p.lng)
          }))
          if (faultCoords.length > 0) {
            this.googleFaultPath = new google.maps.Polyline({
              path: faultCoords,
              strokeColor: '#FF0000',
              strokeOpacity: 0.8,
              strokeWeight: 5,
              map
            })
            this.markerPoint = { lng: faultCoords[0].lng, lat: faultCoords[0].lat }
          }
        })
      }
    },
    // handleMap({ BMap, map }) {
    //   this.map = map
    //   this.BMap = BMap
    //   this.getlngLatAlt()
    // },
    getlngLatAlt () {
      this.loading = true
      const { startTime, endTime } = this.accountSearchRange()
      const data = {
        ebikeId: this.queryInfo.ebikeId,
        startTime,
        endTime
      }
      lngLatAlt(data).then((res) => {
        this.path = []
        this.pathbaidu = []
        this.tableList = []
        // const tableList = []
        this.bikePath = []
        this.pointsMarker = []
        // const pointsMarker = []
        this.startmarkerPointbaidu = { lng: 0, lat: 0 }
        this.endmarkerPointbaidu = { lng: 0, lat: 0 }
        const faultDataList = this.setDataGroup(res.data)
        const tableList = []
        faultDataList.map((items) => {
          const obj = {
            activeKey: '',
            faultCode: '',
            list: []
          }
          obj.activeKey = items.activeKey
          obj.faultCode = items.faultCode
          obj.list = []
          items.list.map((itemss) => {
            if (itemss.lng !== null && itemss.lat !== null && itemss.faultCode === '48' && itemss.isLocation === 1) {

            } else {
              obj.list.push(itemss)
            }
            itemss.index = items.index
          })
          tableList.push(obj)
        })
        tableList.map((item, index) => {
          if (item.list.length > 0) {
            this.tableList.push(item)
          }
        })
        // const faultDataList1 = []
        // res.data.map((item) => {
        //   if ((item.lat === null && item.lng === null) || item.faultCode !== '48') {
        //     faultDataList1.push(item)
        //   }
        // })
        // const faultDataList = this.setDataGroup(faultDataList1)
        // faultDataList.map((items) => {
        //   // if (items.faultCode !== '48') {
        //   items.list.map((itemss) => {
        //     itemss.index = items.index
        //   })
        //   this.tableList.push(items)
        //   // }
        // })
        res.data.map((item) => {
          // 仅北斗定位点（isLocation===1）参与画轨迹，避免基站坐标被当成起点造成直线跳点
          if (item.lng && item.lat && item.isLocation === 1) {
            this.bikePath.push(item)
          }
        })
        this.bikePath.forEach((item) => {
          // const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
          // const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
          // if (item.isLocation === 1) {
          this.pathbaidu.push({
            lng: item.lng,
            lat: item.lat
          })
          // this.pathbaidu.push({
          //   lng: Number(bikepointss[0]),
          //   lat: Number(bikepointss[1])
          // })
          // }
        })
        if (this.pathbaidu.length > 0) {
          this.markerPointbaidu.lng = this.pathbaidu[0].lng
          this.markerPointbaidu.lat = this.pathbaidu[0].lat
          this.startmarkerPointbaidu.lng = this.pathbaidu[0].lng
          this.startmarkerPointbaidu.lat = this.pathbaidu[0].lat
          this.endmarkerPointbaidu.lng = this.pathbaidu[this.pathbaidu.length - 1].lng
          this.endmarkerPointbaidu.lat = this.pathbaidu[this.pathbaidu.length - 1].lat
        }
        this.loading = false
        this.playbaidu = true
        this.isStart = false
        this.scheduleTdtMapRefresh()
        if (this.mapchange === '2') {
          this.refreshGoogleMap(false)
          if (this.dialogVisible) {
            this.refreshGoogleMap(true)
          }
        }
        this.scheduleChartsResize()
      }).catch(() => {
        this.loading = false
        this.scheduleTdtMapRefresh()
        if (this.mapchange === '2') {
          this.refreshGoogleMap(false)
          if (this.dialogVisible) {
            this.refreshGoogleMap(true)
          }
        }
        this.scheduleChartsResize()
      })
    },
    initTdtMap (fullscreen = false) {
      const T = window.T
      if (!T) return false
      const ctx = this.getMapCtx(fullscreen)
      const container = document.getElementById(ctx.containerId)
      if (!container || container.offsetWidth === 0 || container.offsetHeight === 0) return false
      if (!this[ctx.tdtMapKey]) {
        this[ctx.tdtMapKey] = new T.Map(ctx.containerId)
        this[ctx.tdtMapKey].addControl(new T.Control.Zoom())
      }
      return true
    },
    scheduleTdtMapRefresh () {
      this.$nextTick(() => {
        setTimeout(() => this.refreshTdtMap(false), 150)
        setTimeout(() => this.refreshTdtMap(false), 700)
        if (this.dialogVisible) {
          setTimeout(() => this.refreshTdtMap(true), 150)
          setTimeout(() => this.refreshTdtMap(true), 700)
        }
      })
    },
    getTdtCenter () {
      if (this.pathbaidu.length > 0) {
        return {
          lng: this.pathbaidu[0].lng,
          lat: this.pathbaidu[0].lat,
          zoom: resolveInitialZoom(this.pathbaidu.length) || 17
        }
      }
      return { lng: 116.3912757, lat: 39.906217, zoom: 12 }
    },
    clearTdtOverlays (fullscreen = false) {
      const ctx = this.getMapCtx(fullscreen)
      const carTrack = this[ctx.carTrackKey]
      if (carTrack) {
        try {
          carTrack.pause()
          carTrack.state = 4
          if (typeof carTrack._Remove === 'function') {
            carTrack._Remove()
          }
        } catch (e) { /* ignore */ }
        this[ctx.carTrackKey] = null
      }
      const tdtMap = this[ctx.tdtMapKey]
      if (this[ctx.trackPolylineKey] && tdtMap) {
        try {
          tdtMap.removeOverLay(this[ctx.trackPolylineKey])
        } catch (e) { /* ignore */ }
        this[ctx.trackPolylineKey] = null
      }
      if (tdtMap && typeof tdtMap.clearOverLays === 'function') {
        tdtMap.clearOverLays()
      }
    },
    refreshTdtMap (fullscreen = false) {
      if (this.mapchange !== '1') return
      this.$nextTick(() => {
        setTimeout(() => {
          if (!this.initTdtMap(fullscreen)) {
            setTimeout(() => this.refreshTdtMap(fullscreen), 200)
            return
          }
          const T = window.T
          const ctx = this.getMapCtx(fullscreen)
          const tdtMap = this[ctx.tdtMapKey]
          const { lng, lat, zoom } = this.getTdtCenter()
          this.markerPointbaidu.lng = lng
          this.markerPointbaidu.lat = lat
          tdtMap.centerAndZoom(new T.LngLat(lng, lat), zoom)
          if (typeof tdtMap.checkResize === 'function') {
            tdtMap.checkResize()
          }
          this.clearTdtOverlays(fullscreen)
          if (this.pathbaidu.length > 0) {
            this.createStartMarker(fullscreen)
            this.createRoute(fullscreen)
          }
        }, 150)
      })
    },
    createStartMarker (fullscreen = false) {
      var T = window.T
      const ctx = this.getMapCtx(fullscreen)
      const tdtMap = this[ctx.tdtMapKey]
      const start = {
        lat: this.startmarkerPointbaidu.lat,
        lng: this.startmarkerPointbaidu.lng
      }
      var startMarker = new T.Marker(start, {
        icon: new T.Icon({
          iconUrl: this.startmarkericonbaidu.url,
          iconSize: new T.Point(32, 32),
          iconAnchor: new T.Point(16, 32)
        })
      })
      tdtMap.addOverLay(startMarker)
      const end = {
        lat: this.endmarkerPointbaidu.lat,
        lng: this.endmarkerPointbaidu.lng
      }
      var endMarker = new T.Marker(end, {
        icon: new T.Icon({
          iconUrl: this.endmarkericonbaidu.url,
          iconSize: new T.Point(32, 32),
          iconAnchor: new T.Point(16, 32)
        })
      })
      tdtMap.addOverLay(endMarker)
    },
    createRoute (fullscreen = false) {
      const T = window.T
      const that = this
      const ctx = this.getMapCtx(fullscreen)
      const tdtMap = this[ctx.tdtMapKey]
      const trackData = this.pathbaidu
        .map((p) => new T.LngLat(Number(p.lng), Number(p.lat)))
        .filter((p) => !Number.isNaN(p.lng) && !Number.isNaN(p.lat))
      if (trackData.length < 2) return

      that[ctx.carTrackKey] = new T.CarTrack(tdtMap, {
        carstyle: {
          iconUrl: this.icon.url,
          width: 32,
          height: 32
        },
        interval: this.getTrackInterval(),
        speed: 0,
        dynamicLine: false,
        Datas: trackData,
        polylinestyle: { color: '#275aff', width: 8, opacity: 0.8, display: true },
        passOneNode: function (lnglat, index, length) {
          if (index >= length) {
            that[ctx.carTrackKey].pause()
            that.isStart = false
          }
        }
      })
      that.isStart = false
      const carTrack = that[ctx.carTrackKey]
      if (carTrack.carMarker && carTrack.carMarker.setRotate) {
        carTrack.carMarker.setRotate = function () {}
        carTrack.carMarker.setRotate(0)
      }
      if (carTrack.carMarker && carTrack.carMarker.div) {
        carTrack.carMarker.div.style.display = 'none'
      }
    },
    getTrackInterval () {
      return Math.max(50, Math.round((1 / Math.max(this.speed, 1)) * 7000))
    },
    changeTrackSpeed () {
      if (this.mapchange === '1') {
        ;['carTrack', 'carTrackFull'].forEach((key) => {
          const track = this[key]
          if (!track) return
          const wasPlaying = this.isStart
          track.pause()
          track.options.interval = this.getTrackInterval()
          if (wasPlaying) {
            track.start()
          }
        })
      } else if (this.isStart) {
        this.pauseGoogleTrack()
        this.startGoogleTrack()
      }
    },
    hasTrackProgress () {
      if (this.mapchange === '1') {
        const ctx = this.getActiveMapCtx()
        const carTrack = this[ctx.carTrackKey]
        if (!carTrack) return false
        return carTrack.options.Counter > 0 && carTrack.options.Counter < carTrack.options.nodeslength
      }
      return this.count > 0 && this.count < this.path.length
    },
    toggleTrackPlay () {
      if (this.isStart) {
        this.pauseTrack()
      } else if (this.mapchange === '1') {
        this.startTdtTrack()
      } else {
        this.startGoogleTrack()
      }
    },
    pauseTrack () {
      if (this.mapchange === '1') {
        this.pauseTdtTrack()
      } else {
        this.pauseGoogleTrack()
      }
    },
    pauseTdtTrack () {
      const ctx = this.getActiveMapCtx()
      const carTrack = this[ctx.carTrackKey]
      if (carTrack) {
        carTrack.pause()
      }
      this.isStart = false
    },
    pauseGoogleTrack () {
      const ctx = this.getActiveMapCtx()
      clearInterval(this[ctx.animateKey])
      this[ctx.animateKey] = null
      this.isStart = false
    },
    replayTrack () {
      this.pauseTrack()
      if (this.mapchange === '1') {
        this.refreshTdtMap(this.dialogVisible)
        setTimeout(() => this.startTdtTrack(), 400)
      } else {
        this.replayGoogleTrack()
      }
    },
    replayGoogleTrack () {
      const ctx = this.getActiveMapCtx()
      const fullscreen = this.dialogVisible
      clearInterval(this[ctx.animateKey])
      this[ctx.animateKey] = null
      this.count = 0
      this.count2 = 0
      this.isStart = false
      const marker = this[ctx.markerKey]
      if (!marker || !this.path.length) {
        this.refreshGoogleMap(fullscreen)
        setTimeout(() => this.replayGoogleTrack(), 300)
        return
      }
      marker.setPosition(this.path[0])
      marker.setIcon(this.bikemarkericon)
      this.startGoogleTrack()
    },
    setDataGroup (list) {
      // console.log('原数组----')
      // console.log(list)
      const result = {}
      var activeKey = ''
      var activeFaultCode = ''
      var activeIsLocation = ''
      list.map((item, index) => {
        // if (item.faultCode !== activeFaultCode && item.isLocation !== activeIsLocation) {
        if (item.faultCode !== activeFaultCode) {
          activeFaultCode = item.faultCode
          activeIsLocation = item.isLocation
          activeKey = 'activeKey-' + index
          result[activeKey] = {
            faultCode: '',
            activeKey: index,
            list: []
          }
          result[activeKey].faultCode = item.faultCode
          result[activeKey].list.push(item)
        } else {
          if (item.isLocation !== activeIsLocation) {
            activeIsLocation = item.isLocation
            activeKey = 'activeKey-' + index
            result[activeKey] = {
              faultCode: '',
              activeKey: index,
              list: []
            }
            result[activeKey].faultCode = item.faultCode
            result[activeKey].list.push(item)
          } else {
            result[activeKey].list.push(item)
          }
          // result[activeKey].list.push(item)
        }
      })
      // console.log('区间分组数据----')
      // console.log(result)
      const faultDataList = []
      for (const key in result) {
        // console.log('key的值是：' + key)
        faultDataList.push(result[key])
      }
      // console.log('faultDataList====', faultDataList)
      return faultDataList
    },
    startTdtTrack () {
      if (!this.pathbaidu.length) return
      if (this.isStart) return
      const ctx = this.getActiveMapCtx()
      const carTrack = this[ctx.carTrackKey]
      if (!carTrack) {
        this.refreshTdtMap(this.dialogVisible)
        setTimeout(() => this.startTdtTrack(), 400)
        return
      }
      const finished = carTrack.options.Counter >= carTrack.options.nodeslength
      if (finished) {
        this.refreshTdtMap(this.dialogVisible)
        setTimeout(() => this.startTdtTrack(), 400)
        return
      }
      if (carTrack.carMarker && carTrack.carMarker.div) {
        carTrack.carMarker.div.style.display = 'block'
      }
      this.isStart = true
      carTrack.start()
    },
    startGoogleTrack () {
      if (this.isStart) return
      const ctx = this.getActiveMapCtx()
      const fullscreen = this.dialogVisible
      if (!this.path.length) {
        if (this.mapchange === '2') {
          this.refreshGoogleMap(fullscreen)
          setTimeout(() => this.startGoogleTrack(), 300)
        }
        return
      }
      const mapRef = this.$refs[ctx.googleRef]
      if (!this[ctx.markerKey] && mapRef) {
        mapRef.$mapPromise.then((map) => {
          this.drawGoogleTrack(map, fullscreen)
          this.startGoogleTrack()
        }).catch(() => {})
        return
      }
      clearInterval(this[ctx.animateKey])
      const marker = this[ctx.markerKey]
      if (this.count >= this.path.length) {
        this.count = 0
        this.count2 = 0
      }
      if (marker && this.path.length > 0) {
        marker.setPosition(this.path[this.count])
        marker.setIcon(this.bikemarkericon)
      }
      this.isStart = true
      this[ctx.animateKey] = setInterval(() => {
        if (!marker || !this.path.length) {
          clearInterval(this[ctx.animateKey])
          this[ctx.animateKey] = null
          this.isStart = false
          return
        }
        marker.setPosition(this.path[this.count])
        this.count += 1
        this.count2 = this.count
        if (this.count >= this.path.length) {
          marker.setPosition(this.path[this.path.length - 1])
          this.count2 = 0
          this.count = 0
          clearInterval(this[ctx.animateKey])
          this[ctx.animateKey] = null
          this.isStart = false
        }
      }, this.getTrackInterval())
    },
    bikePolyLine () {
      if (!this.$refs.mapRef) return
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.drawGoogleTrack(map)
      }).catch(() => {})
    },
    flipImageVertical (src, width, height) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height
            const ctx = canvas.getContext('2d')
            ctx.translate(0, height)
            ctx.scale(1, -1)
            ctx.drawImage(img, 0, 0, width, height)
            resolve(canvas.toDataURL('image/png'))
          } catch (e) {
            resolve(src)
          }
        }
        img.onerror = () => resolve(src)
        img.src = src
      })
    },
    initBikeIcons () {
      const bikeUrl = require('@/assets/bike.png')
      return this.flipImageVertical(bikeUrl, 32, 32).then((flippedUrl) => {
        this.icon.url = flippedUrl
        this.bikemarkericon = {
          url: flippedUrl,
          size: { width: 32, height: 32 },
          scaledSize: { width: 32, height: 32 }
        }
      })
    },
    getGoogleLatLngPath () {
      return this.path
        .map((p) => ({ lat: Number(p.lat), lng: Number(p.lng) }))
        .filter((p) => !Number.isNaN(p.lat) && !Number.isNaN(p.lng))
    },
    drawGoogleTrack (map, fullscreen = false) {
      const google = window.google
      if (!google || !google.maps || !map) return

      const coords = this.getGoogleLatLngPath()
      if (coords.length === 0) return

      const ctx = this.getMapCtx(fullscreen)
      if (this[ctx.flightPathKey]) {
        this[ctx.flightPathKey].setMap(null)
        this[ctx.flightPathKey] = null
      }
      if (this[ctx.markerKey]) {
        this[ctx.markerKey].setMap(null)
        this[ctx.markerKey] = null
      }

      this[ctx.flightPathKey] = new google.maps.Polyline({
        path: coords,
        strokeColor: '#275aff',
        strokeOpacity: 0.8,
        strokeWeight: 5,
        map
      })

      if (coords.length > 1) {
        const bounds = new google.maps.LatLngBounds()
        coords.forEach((p) => bounds.extend(p))
        map.fitBounds(bounds, 48)
      } else {
        map.setCenter(coords[0])
        map.setZoom(18)
      }

      this[ctx.markerKey] = new google.maps.Marker({
        position: coords[0],
        map,
        icon: this.bikemarkericon
      })
    },
    buildGooglePath () {
      // pathbaidu 存的是 WGS84；谷歌国内瓦片需 GCJ02，海外保持 WGS84
      this.path = this.pathbaidu
        .map((item) => toMapLngLat(Number(item.lng), Number(item.lat), 'google'))
        .filter(Boolean)
      if (this.path.length === 0) return false
      const first = this.path[0]
      const last = this.path[this.path.length - 1]
      this.markerPoint = { lng: first.lng, lat: first.lat }
      this.startmarkerPoint = { lng: first.lng, lat: first.lat }
      this.endmarkerPoint = { lng: last.lng, lat: last.lat }
      return true
    },
    refreshGoogleMap (fullscreen = false, retry = 0) {
      if (this.mapchange !== '2') return
      const hasPath = this.buildGooglePath()
      const ctx = this.getMapCtx(fullscreen)
      this.$nextTick(() => {
        setTimeout(() => {
          const mapRef = this.$refs[ctx.googleRef]
          if (!mapRef) {
            if (retry < 8) {
              this.refreshGoogleMap(fullscreen, retry + 1)
            }
            return
          }
          mapRef.$mapPromise.then((map) => {
            if (window.google && window.google.maps) {
              window.google.maps.event.trigger(map, 'resize')
            }
            if (hasPath) {
              this.drawGoogleTrack(map, fullscreen)
            }
          }).catch(() => {
            if (retry < 8) {
              this.refreshGoogleMap(fullscreen, retry + 1)
            }
          })
        }, fullscreen ? 300 : (retry === 0 ? 200 : 150))
      })
    },
    mapchangeradio () {
      this.clickIndex = -1
      this.pauseTrack()
      if (this.mapchange === '1') {
        this.refreshTdtMap(false)
        if (this.dialogVisible) {
          this.refreshTdtMap(true)
        }
      } else {
        this.refreshGoogleMap(false)
        if (this.dialogVisible) {
          this.refreshGoogleMap(true)
        }
      }
    },
    getTenantList () {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }
      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    changeTenant (id) {
      listEbikeIdByTenantId({ tenantId: id })
        .then((res) => {
          this.ebikeIdOptions = res.data
        })
        .catch(() => {
          this.ebikeIdOptions = []
        })
    },
    showAddReport () {
      this.$refs.queryFormRef2.validate(async (valid) => {
        if (!valid) return
        this.tenantIds = []
        this.tenantIds.push(parseInt(this.topData.vendorId))
        const { startTime, endTime } = this.accountSearchRange()
        this.reportInfo = {
          tenantId: parseInt(this.topData.vendorId),
          ebikeId: this.queryInfo.ebikeId,
          startTime,
          endTime
        }
        this.reportDialog = true
      })
    },
    showDataSourceDialog () {
      this.$refs.queryFormRef2.validate(async (valid) => {
        if (!valid) return
        this.dataSourceDialog = true
        this.dataSourceLoading = true
        const { startTime, endTime } = this.accountSearchRange()
        const data = {
          ebikeId: this.queryInfo.ebikeId,
          startTime,
          endTime,
        }
        getEbikeDebugReportList(data).then(res => {
          this.dataSourceLoading = false
          this.dataSourceCustomColumnCount = res.data.customColumnCount || 0
          this.dataSourceRawList = res.data && res.data.dataSourceList
            ? JSON.parse(JSON.stringify(res.data.dataSourceList))
            : []
          if (this.dataSourceRawList.length) {
            this.selectedColumns = []
            this.applyDataSourceI18n()
          } else {
            this.dataSourceList = []
            this.allColumns = []
            this.dataSourceColumns = []
            this.selectedColumns = []
          }
        }).catch(() => {
          this.dataSourceLoading = false
        })
      })
    },
    closeDataSourceDialog () {
      this.dataSourceDialog = false
      this.dataSourceList = []
      this.dataSourceRawList = []
      this.dataSourceCustomColumnCount = 0
      this.dataSourceColumns = []
      this.allColumns = []
      this.selectedColumns = []
      this.showColumnConfig = false
    },
    // 切换列配置对话框
    toggleColumnConfig () {
      this.showColumnConfig = !this.showColumnConfig
    },
    // 保存列配置
    saveColumnConfig () {
      // 根据选中的列更新显示的列
      this.dataSourceColumns = this.allColumns.filter(col =>
        this.selectedColumns.includes(col.prop)
      )
      this.showColumnConfig = false
    },
    // 全选/取消全选
    toggleSelectAll (value) {
      if (value) {
        this.selectedColumns = this.allColumns.map(col => col.prop)
      } else {
        this.selectedColumns = []
      }
    },
    submitReport () {
      this.$refs.reportFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          ebikeDebugReportAdd(this.reportInfo).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$message({ message: this.$t('public.name41'), type: 'success' })
              this.close()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    close () {
      this.reportInfo = {
        tenantId: '',
        ebikeId: '',
        startTime: '',
        endTime: ''
      }
      this.reportDialog = false
    },
    loadOptions (node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => { })
    },
    handleChange (value) {
      // 处理选项变化
      this.reportInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.visualReport-container {
  display: flex;
  flex-direction: column;

  .margin-top20 {
    margin-top: 20px;
  }

  .width100 {
    width: 100%;
  }

  .content-one {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .item-one {
      width: 480px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .caution {
      width: 35px;
      height: 35px;
      margin-right: 15px;
    }
  }

  .map-toolbar {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.96);
    padding: 10px 12px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: calc(100% - 56px);
    box-sizing: border-box;
  }

  .map-radio-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 14px;
    line-height: 1.4;

    .map-type-label {
      flex-shrink: 0;
      font-size: 14px;
      color: #333;
      white-space: nowrap;
    }

    ::v-deep .el-radio {
      margin-right: 0;
      white-space: nowrap;
    }

    ::v-deep .el-radio__label {
      font-size: 14px;
      padding-left: 6px;
    }
  }

  .map-track-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 240px;

    .gjsd {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
    }

    .track-speed-label {
      flex-shrink: 0;
      font-size: 14px;
      color: #333;
      white-space: nowrap;
    }

    .el-slider {
      flex: 1;
      min-width: 100px;
      margin: 0 4px;
    }

    .map-track-btn {
      align-self: flex-start;
      min-width: 88px;
      padding: 8px 15px;

      ::v-deep [class*='el-icon-'] + span {
        margin-left: 4px;
      }
    }

    .map-track-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
  }

  .dydl-wd {
    width: 100%;
    display: flex;
    flex-direction: row;

    .dydl-container {
      position: relative;
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 1px solid #f1f1f1;
      padding: 10px;
      box-sizing: border-box;

      .dcdy,
      .dcdl {
        flex-shrink: 0;
      }
    }

    .dydl {
      flex: 1;
      min-width: 0;
      width: auto;
      height: 400px;
    }

    .bll-select {
      width: 180px;
      margin-left: 20px;
      position: absolute;
      left: 0;
      top: 10px;
      display: flex;
      z-index: 100;
      justify-content: space-between;
      align-items: center;
    }

    .wd-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 600;
    }

    .writing-mode {
      writing-mode: vertical-rl;
    }

    .dcdy {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #42bf7c;
      font-weight: 600;
    }

    .dcdl {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #5a7ff1;
      font-weight: 600;
    }

    .gz-table {
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 400px;
      padding: 10px;
      box-sizing: border-box;
      min-width: 0;
      overflow: hidden;

      // 故障时间需容纳 yyyy-MM-dd HH:mm:ss + 选中图标；中英列表头分别保证单行完整
      $fault-cols: 190px 80px minmax(72px, 1.2fr) minmax(48px, 1fr) 48px;
      $fault-cols-en: 190px 178px minmax(148px, 1.3fr) minmax(72px, 0.9fr) 72px;

      .table-title,
      .item-content {
        display: grid;
        grid-template-columns: $fault-cols;
        column-gap: 10px;
        align-items: center;
        width: 100%;
        min-width: 0;
      }

      &.gz-table--en {
        overflow-x: auto;
        overflow-y: hidden;

        .table-title,
        .item-content {
          grid-template-columns: $fault-cols-en;
          // 约 190+178+148+72+72+4×10，窄屏时横向滚动而非挤压重叠
          min-width: 720px;
        }
      }

      .table-title {
        flex-shrink: 0;
        font-size: 16px;
        font-weight: 600;
        color: #555;
        padding: 8px 4px;
        border-bottom: 1px solid #e8e8e8;
        background: #f5f5f5;

        > div {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .table-rows {
        flex: 1;
        min-height: 0;
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;
      }

      .row1,
      .row2,
      .row3,
      .row4,
      .row5 {
        width: auto;
        min-width: 0;
      }

      .cell-ellipsis {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }

      .cell-wrap {
        word-break: break-word;
        white-space: normal;
        line-height: 1.4;
      }

      .cell-time {
        display: flex;
        align-items: flex-start;
        gap: 4px;
        font-size: 16px;
        line-height: 1.4;
        font-variant-numeric: tabular-nums;
        color: #333;
        width: 100%;
        min-width: 0;
        white-space: nowrap;
        box-sizing: border-box;

        .el-tooltip {
          flex: 1 1 auto;
          min-width: 0;
          max-width: 100%;
        }

        .time-range {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
          max-width: 100%;
        }

        .time-link {
          cursor: pointer;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;

          &:hover {
            color: #0f73e6;
          }
        }
      }

      .row-active-icon {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
        margin-top: 2px;
      }

      .cell-code {
        font-size: 16px;
        text-align: center;
        color: #333;
      }

      .cell-msg {
        font-size: 16px;
        line-height: 1.4;
        color: #555;
        min-width: 0;

        .el-tooltip {
          display: block;
          min-width: 0;
        }
      }

      .cell-remark {
        font-size: 16px;
        color: #888;
        text-align: center;
      }

      .cell-action {
        flex-shrink: 0;
        width: 48px;
        text-align: center;

        .el-button {
          padding: 0;
        }
      }

      .nodata {
        padding: 48px 16px;
        text-align: center;
        color: #999;
        font-size: 16px;
      }

      .item-content-active {
        background: #eef5fd;
      }

      .item-content {
        padding: 10px 4px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.15s;

        &:hover {
          background: #fafafa;
        }

        &.item-content-active:hover {
          background: #eef5fd;
        }
      }
    }

    .margin-left15 {
      margin-left: 15px;
    }

    .wd-container {
      position: relative;
      width: 50%;
      min-width: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 1px solid #f1f1f1;
      padding: 10px;
      box-sizing: border-box;

      .wd-text {
        flex-shrink: 0;
      }

      .wd {
        flex: 1;
        min-width: 0;
        width: auto;
        height: 400px;
      }

      &.wd-container--map {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
      }
    }
  }

  .baidu-map {
    width: 100%;
    position: relative;
  }

  .gooles-map {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    min-height: 420px;

    // vue2-google-maps: .vue-map 为 absolute，容器必须有确定高度，否则 flex 下塌成 0
    .map,
    ::v-deep .vue-map-container {
      width: 100%;
      height: 420px !important;
      min-height: 420px;
      flex-shrink: 0;
    }
  }

  .map {
    width: 100%;
    height: 420px;
    min-height: 420px;
  }

  .map-fullscreen-btn {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 1000;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 18px;
    line-height: 1;

    &:hover {
      background: #fff;
      color: #409eff;
    }
  }

  .top-filter {
    display: flex;
    justify-content: space-between;

    .caution {
      width: 35px;
      height: 35px;
    }
  }

  .top-ds {
    // width: 100%;
    display: flex;
    justify-content: space-between;
    height: 100px;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding: 0px 15px;

    .item {
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;

      .label {
        font-size: 18px;
        font-weight: 700;
      }

      .value {
        font-family: 'D-DIN-PRO-700';
        font-size: 18px;
      }

      .margin-top10 {
        margin-top: 10px;
      }
    }
  }

  .input {
    width: px2vw(147);
  }

  .form-item2 {
    margin-left: px2vw(-15);
  }

  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
    margin-bottom: 20px;
  }
}
</style>

<style lang="scss">
.el-dialog.is-fullscreen.report-map-fullscreen-dialog {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 3000 !important;

  .el-dialog__body {
    flex: 1 1 auto;
    min-height: 0;
    padding: 12px 16px 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .full-map-shell {
    position: relative;
    flex: 1;
    min-height: 0;
    width: 100%;
    height: 100%;
  }

  .full-map-body {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .full-map-pane {
    width: 100%;
    height: 100%;
  }

  .map--full {
    width: 100% !important;
    height: 100% !important;
    min-height: 400px;
  }

  .map-toolbar {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.96);
    padding: 10px 12px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: calc(100% - 56px);
    box-sizing: border-box;
  }

  .map-radio-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 14px;
    line-height: 1.4;

    .map-type-label {
      flex-shrink: 0;
      font-size: 14px;
      color: #333;
      white-space: nowrap;
    }

    .el-radio {
      margin-right: 0;
      white-space: nowrap;
    }

    .el-radio__label {
      font-size: 14px;
      padding-left: 6px;
    }
  }

  .map-track-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 240px;

    .gjsd {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
    }

    .track-speed-label {
      flex-shrink: 0;
      font-size: 14px;
      color: #333;
      white-space: nowrap;
    }

    .el-slider {
      flex: 1;
      min-width: 100px;
      margin: 0 4px;
    }

    .map-track-btn {
      align-self: flex-start;
      min-width: 88px;
      padding: 8px 15px;
    }

    .map-track-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
  }
}
</style>
